((Tabs, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.tabs = $('.js-tab');
    $dom.tabPanels = $('.js-tab-panel');
  }

  const toggleTab = (event) => {
    if (window.innerWidth >= 768) {
      return;
    }

    const $self = $(event.currentTarget);
    const target = $self.data('target'); 
    const $panel = $dom.tabPanels.filter('[data-tab="' + target + '"]');
    $self.toggleClass('is-active');
    $panel.toggle(300);
  }

  const bindUIActions = () => {
    $dom.tabs.on('click', toggleTab);
  }

  const init = () => {
    cacheDom();
    bindUIActions();
  }

  Tabs.init = init;
  
})(window.Tabs = window.Tabs || {}, jQuery);